import { render } from "./TerminalSettingsView.vue?vue&type=template&id=87897b46&scoped=true"
import script from "./TerminalSettingsView.vue?vue&type=script&setup=true&lang=js"
export * from "./TerminalSettingsView.vue?vue&type=script&setup=true&lang=js"

import "./TerminalSettingsView.vue?vue&type=style&index=0&id=87897b46&scoped=true&lang=css"

import exportComponent from "/Volumes/Projects/wp_all_repo/wp-content/plugins/debug-log-config-tool/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87897b46"],['__file',"resources/views/TerminalSettingsView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "87897b46"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('87897b46', __exports__)) {
    console.log('reload')
    api.reload('87897b46', __exports__)
  }
  
  module.hot.accept("./TerminalSettingsView.vue?vue&type=template&id=87897b46&scoped=true", () => {
    console.log('re-render')
    api.rerender('87897b46', render)
  })

}


export default __exports__